import React from 'react';

import { useApp } from '../store/AppContext';
import SidebarCollapseButton from './sidebarHeader/SidebarCollapseButton';

export default function SidebarHeader() {
  const { navLogoRef } = useApp();
  return (
    <div ref={navLogoRef} className="logo justify-center relative py-[0] px-[16px]">
      <SidebarCollapseButton />
    </div>
  );
}
